import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';
import AllDefaultProfile from './MyProfile/AccountProfile';
import AllActiveProfile from './MyProfile/ActiveProfile';

export const accountPagesConfigs = [
  {
    permittedRole: RoutePermittedRole.all,
    path: '/my-profile',
    element: <AllDefaultProfile/>,
  },
  {
    permittedRole:RoutePermittedRole.all,
    path:'/my-profile-update-request',
    element: <AllActiveProfile/>,
  }
];
